import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListNilaiRapor } from "@/services/getData"
import { useSearchParams } from "react-router-dom"

export default function SyncNilaiRaporPage() {
  const [searchParams] = useSearchParams()
  const page = searchParams.get("page") || "1"
  const rowsPerPage = searchParams.get("rowsPerPage") || "10"
  const search = searchParams.get("search") || ""

  const { data, isPending } = useQuery({
    queryKey: ["listNilaiRaporSNBP", page, rowsPerPage, search],
    queryFn: () => getListNilaiRapor(page, rowsPerPage, search),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  )
}
